export default {
  'pages.layouts.userLayout.title':
    'A management system based on the Apple MDM protocol。',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.auth.success': 'Auth successful',
  'pages.adde.title': 'Device Enrollment',
  'pages.adde.subtitle': 'Continue enrollment for your device.',
  'pages.byod.title': 'User Enrollment',
  'pages.byod.subtitle': 'Continue enrollment for your work account.',
  'pages.byod.context.missing':
    'Missing enrollment context. Please restart from Settings.',
  'pages.byod.session.expired':
    'Enrollment session expired. Please restart from Settings.',
  'pages.byod.register.prompt':
    'No managed Apple ID was found. Complete the registration details below to continue.',
  'pages.byod.register.email-target':
    'The verification code will be sent to this Managed Apple ID email: {email}.',
  'pages.byod.register.family-name': 'Family Name',
  'pages.byod.register.family-name.required': 'Please enter Family Name.',
  'pages.byod.register.given-name': 'Given Name',
  'pages.byod.register.given-name.required': 'Please enter Given Name.',
  'pages.byod.register.department': 'Department',
  'pages.byod.register.department.required': 'Please enter Department.',
  'pages.byod.code.send': 'Send Verification Code',
  'pages.byod.code.send-success': 'Verification code sent successfully.',
  'pages.byod.code.send-failed': 'Failed to send verification code.',
  'pages.byod.code.no-email': 'No email address is available for verification.',
  'pages.byod.code.invalid-email': 'The verification email address is invalid.',
  'pages.byod.code.mailbox-unavailable':
    'Verification email delivery failed: recipient mailbox was not found or cannot receive emails.',
  'pages.byod.code.sent': 'Verification code sent to {email}.',
  'pages.byod.code.resend-wait': 'Resend in {seconds}s',
  'pages.byod.code.placeholder': 'Verification Code',
  'pages.byod.code.required': 'Please enter the verification code.',
  'pages.byod.code.invalidated':
    'Registration details changed. Please request a new verification code.',
  'pages.byod.auth.failed': 'Authentication failed. Please try again.',
  'pages.byod.auth.invalid-code': 'Invalid or expired verification code.',
  'pages.byod.auth.session-expired':
    'Enrollment session expired. Please restart from Settings.',
  'pages.byod.submit': 'Continue',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Please input password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.otp.placeholder': 'OTP Code',
  'pages.login.otp.required': 'Please input your OTP code!',
  'pages.login.otp.invalid': 'OTP code must be 6 digits!',
  'pages.login.submit.otp': 'Verify',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'app.account.center.title': 'Enterprise User Management',
  'app.account.center.description':
    'View all users in the current enterprise and disable specific users.',
  'app.account.center.current-business': 'Current Business',
  'app.account.center.user-name': 'Username',
  'app.account.center.email': 'Email',
  'app.account.center.email-required': 'Please input an email address',
  'app.account.center.email-invalid': 'Email format is invalid',
  'app.account.center.email-placeholder': 'Please input an email address',
  'app.account.center.business-code': 'Business Code',
  'app.account.center.otp-status': 'OTP Status',
  'app.account.center.enabled': 'Enabled',
  'app.account.center.disabled': 'Not Enabled',
  'app.account.center.user-status': 'User Status',
  'app.account.center.status.normal': 'Normal',
  'app.account.center.status.disabled': 'Disabled',
  'app.account.center.status.locked': 'Locked',
  'app.account.center.status.unknown': 'Unknown',
  'app.account.center.create-time': 'Created At',
  'app.account.center.actions': 'Actions',
  'app.account.center.already-disabled': 'Disabled',
  'app.account.center.disable-confirm-title': 'Disable this user?',
  'app.account.center.disable-confirm-description':
    'The user will no longer be able to sign in after being disabled.',
  'app.account.center.confirm': 'Confirm',
  'app.account.center.cancel': 'Cancel',
  'app.account.center.disable-user': 'Disable User',
  'app.account.center.edit-email': 'Edit Email',
  'app.account.center.disable-success': 'User has been disabled',
  'app.account.center.disable-failed': 'Failed to disable user',
  'app.account.center.update-email-success': 'Email updated successfully',
  'app.account.center.update-email-failed': 'Failed to update email',
  'app.account.center.create-user': 'Create User',
  'app.account.center.create-success': 'User created successfully',
  'app.account.center.create-failed': 'Failed to create user',
  'app.account.center.user-name-required': 'Please input a username',
  'app.account.center.user-name-placeholder': 'Please input a username',
  'app.account.center.password': 'Login Password',
  'app.account.center.password-required': 'Please input a password',
  'app.account.center.password-placeholder': 'Please input a password',
  'app.account.center.password-rule':
    '8-20 characters with uppercase, lowercase, number, and special character @$!%*?&',
  'app.account.center.confirm-password': 'Confirm Password',
  'app.account.center.confirm-password-required': 'Please confirm the password',
  'app.account.center.confirm-password-placeholder':
    'Please confirm the password',
  'app.account.center.confirm-password-mismatch':
    'The two passwords do not match',
  'app.settings.s3.title': 'S3 Storage Settings',
  'app.settings.s3.description':
    'Configure S3 storage for the current business and test connection before saving.',
  'app.settings.s3.endpoint': 'Endpoint',
  'app.settings.s3.region': 'Region',
  'app.settings.s3.bucket': 'Bucket',
  'app.settings.s3.key-prefix': 'Key Prefix',
  'app.settings.s3.access-key-id': 'Access Key ID',
  'app.settings.s3.secret-access-key': 'Secret Access Key',
  'app.settings.s3.force-path-style': 'Force Path Style',
  'app.settings.s3.endpoint-required': 'Please input Endpoint',
  'app.settings.s3.region-required': 'Please input Region',
  'app.settings.s3.bucket-required': 'Please input Bucket',
  'app.settings.s3.access-key-id-required': 'Please input Access Key ID',
  'app.settings.s3.secret-placeholder':
    'Leave empty to keep the saved Secret Access Key',
  'app.settings.s3.secret-reuse':
    'A secret is already configured. Leaving this empty reuses the saved secret.',
  'app.settings.s3.test-button': 'Test Connection',
  'app.settings.s3.save-button': 'Save Configuration',
  'app.settings.s3.load-failed': 'Failed to load S3 configuration',
  'app.settings.s3.save-success': 'S3 configuration saved successfully',
  'app.settings.s3.save-failed': 'Failed to save S3 configuration',
  'app.settings.s3.test-success': 'S3 connection test succeeded',
  'app.settings.s3.test-failed': 'S3 connection test failed',
  'app.settings.smtp.title': 'SMTP Settings',
  'app.settings.smtp.description':
    'Configure SMTP for the current business. Saving is only allowed after a successful test email.',
  'app.settings.smtp.host': 'SMTP Host',
  'app.settings.smtp.port': 'SMTP Port',
  'app.settings.smtp.username': 'Username',
  'app.settings.smtp.password': 'Password',
  'app.settings.smtp.from-email': 'From Email',
  'app.settings.smtp.from-name': 'From Name',
  'app.settings.smtp.security-mode': 'Security Mode',
  'app.settings.smtp.test-recipient': 'Test Recipient',
  'app.settings.smtp.host-required': 'Please input SMTP Host',
  'app.settings.smtp.port-required': 'Please input SMTP Port',
  'app.settings.smtp.port-invalid':
    'SMTP Port must be an integer between 1 and 65535',
  'app.settings.smtp.username-required': 'Please input username',
  'app.settings.smtp.password-required': 'Please input password',
  'app.settings.smtp.from-email-required': 'Please input from email',
  'app.settings.smtp.from-email-invalid': 'From email is invalid',
  'app.settings.smtp.from-name-required': 'Please input from name',
  'app.settings.smtp.security-mode-required': 'Please select a security mode',
  'app.settings.smtp.test-recipient-required': 'Please input a test recipient',
  'app.settings.smtp.test-recipient-invalid': 'Test recipient email is invalid',
  'app.settings.smtp.password-placeholder':
    'Leave empty to keep the saved password',
  'app.settings.smtp.password-reuse':
    'A password is already configured. Leaving this empty reuses the saved password.',
  'app.settings.smtp.security-mode.none': 'None',
  'app.settings.smtp.security-mode.starttls': 'STARTTLS',
  'app.settings.smtp.security-mode.ssl-tls': 'SSL/TLS',
  'app.settings.smtp.test-button': 'Send Test Email',
  'app.settings.smtp.save-button': 'Save Configuration',
  'app.settings.smtp.load-failed': 'Failed to load SMTP configuration',
  'app.settings.smtp.save-success': 'SMTP configuration saved successfully',
  'app.settings.smtp.save-failed': 'Failed to save SMTP configuration',
  'app.settings.smtp.test-success': 'SMTP test email sent successfully',
  'app.settings.smtp.test-failed': 'SMTP test failed',
  'app.settings.smtp.save-disabled-hint':
    'Please send a successful test email for the current configuration before saving.',
  'app.settings.smtp.retest-required':
    'The configuration changed. Re-test SMTP before saving.',
  'app.settings.backup.title': 'Platform Backup',
  'app.settings.backup.description':
    'Manually back up current business data to the configured S3 backup directory.',
  'app.settings.backup.manual-button': 'Manual Backup',
  'app.settings.backup.manual-success': 'Manual backup completed',
  'app.settings.backup.manual-failed': 'Manual backup failed',
  'app.settings.backup.load-failed': 'Failed to load backup records',
  'app.settings.backup.table.create-date': 'Created At',
  'app.settings.backup.table.status': 'Status',
  'app.settings.backup.table.bucket': 'Bucket',
  'app.settings.backup.table.key': 'Object Key',
  'app.settings.backup.table.file-size': 'File Size',
  'app.settings.backup.table.table-count': 'Table Count',
  'app.settings.backup.table.row-count': 'Row Count',
  'app.settings.backup.table.message': 'Message',
  'app.settings.backup.status.success': 'Success',
  'app.settings.backup.status.failed': 'Failed',
  'app.business.managed-apple-id.title': 'Managed Apple ID List',
  'app.business.managed-apple-id.description':
    'View the Managed Apple ID mirror accounts for the current business.',
  'app.business.managed-apple-id.load-failed':
    'Failed to load the Managed Apple ID list',
  'app.business.managed-apple-id.table.name': 'Name',
  'app.business.managed-apple-id.table.family-name': 'Family Name',
  'app.business.managed-apple-id.table.given-name': 'Given Name',
  'app.business.managed-apple-id.table.preferred-username':
    'Preferred Username',
  'app.business.managed-apple-id.table.email': 'Email',
  'app.business.managed-apple-id.table.email-verified': 'Email Verified',
  'app.business.managed-apple-id.table.department': 'Department',
  'app.business.managed-apple-id.table.create-time': 'Created At',
  'app.business.managed-apple-id.email-verified.yes': 'Verified',
  'app.business.managed-apple-id.email-verified.no': 'Not Verified',
  'app.business.managed-apple-id.table.status': 'Status',
  'app.business.managed-apple-id.table.actions': 'Actions',
  'app.business.managed-apple-id.status.normal': 'Normal',
  'app.business.managed-apple-id.status.disabled': 'Disabled',
  'app.business.managed-apple-id.action.disable': 'Disable',
  'app.business.managed-apple-id.action.enable': 'Enable',
  'app.business.managed-apple-id.disable-confirm-title':
    'Disable this Managed Apple ID?',
  'app.business.managed-apple-id.disable-confirm-description':
    'A session-revoked event will be sent to Apple Business Manager via SSF.',
  'app.business.managed-apple-id.enable-confirm-title':
    'Enable this Managed Apple ID?',
  'app.business.managed-apple-id.confirm': 'Confirm',
  'app.business.managed-apple-id.cancel': 'Cancel',
  'app.business.managed-apple-id.disable-success': 'Disabled',
  'app.business.managed-apple-id.enable-success': 'Enabled',
  'app.business.managed-apple-id.status-change-failed':
    'Failed to update status',
  // ===== SSF Event Log =====
  'app.event.ssf-log.title': 'SSF Event Log',
  'app.event.ssf-log.description':
    'View the SSF (Shared Signals Framework) event push history.',
  'app.event.ssf-log.load-failed': 'Failed to load SSF event log',
  'app.event.ssf-log.table.event-type': 'Event Type',
  'app.event.ssf-log.table.target-email': 'Target Email',
  'app.event.ssf-log.table.stream-id': 'Stream ID',
  'app.event.ssf-log.table.push-status': 'Push Status',
  'app.event.ssf-log.table.http-status': 'HTTP Status',
  'app.event.ssf-log.table.detail': 'Detail',
  'app.event.ssf-log.table.created-at': 'Pushed At',
  'app.event.ssf-log.status.success': 'Success',
  'app.event.ssf-log.status.failed': 'Failed',
  'app.event.ssf-log.detail.view': 'View',
  'app.event.ssf-log.detail.error': 'Error Message',
  'app.event.ssf-log.detail.response': 'Response Body',
  // ===== OIDC Applications =====
  'app.oidc-apps.title': 'OIDC Applications',
  'app.oidc-apps.description':
    'Manage OIDC client applications, redirect URIs, and client secrets for the current tenant.',
  'app.oidc-apps.create-button': 'Create Application',
  'app.oidc-apps.load-failed': 'Failed to load OIDC application list',
  'app.oidc-apps.detail-load-failed': 'Failed to load application detail',
  'app.oidc-apps.create-success': 'Application created successfully',
  'app.oidc-apps.create-failed': 'Failed to create application',
  'app.oidc-apps.status-change-failed': 'Failed to update application status',
  'app.oidc-apps.enabled': 'Application enabled',
  'app.oidc-apps.disabled': 'Application disabled',
  'app.oidc-apps.delete-success': 'Application deleted',
  'app.oidc-apps.delete-failed': 'Failed to delete application',
  'app.oidc-apps.col.app-name': 'Application Name',
  'app.oidc-apps.col.status': 'Status',
  'app.oidc-apps.col.redirect-count': 'Redirect URIs',
  'app.oidc-apps.col.secret-last4': 'Secret (last 4)',
  'app.oidc-apps.col.secret-created-at': 'Secret Created At',
  'app.oidc-apps.col.created-at': 'Created At',
  'app.oidc-apps.col.actions': 'Actions',
  'app.oidc-apps.action.view': 'View',
  'app.oidc-apps.action.disable': 'Disable',
  'app.oidc-apps.action.enable': 'Enable',
  'app.oidc-apps.action.delete': 'Delete',
  'app.oidc-apps.delete-confirm-title': 'Delete Application',
  'app.oidc-apps.delete-confirm-desc':
    'After deletion, the application will no longer appear in the list and protocol flows will be rejected immediately.',
  'app.oidc-apps.create-modal-title': 'Create OIDC Application',
  'app.oidc-apps.create-ok': 'Create',
  'app.oidc-apps.create-cancel': 'Cancel',
  'app.oidc-apps.form.app-name': 'Application Name',
  'app.oidc-apps.form.app-name-required': 'Please enter application name',
  'app.oidc-apps.form.app-name-placeholder': 'e.g. Apple Business Manager',
  'app.oidc-apps.form.redirect-uris': 'Allowed Redirect URIs',
  'app.oidc-apps.form.redirect-uris-hint':
    'Defaults to Apple ABM ACS callback address; if left blank, it will fallback to that address automatically.',
  'app.oidc-apps.form.redirect-remove': 'Remove',
  'app.oidc-apps.form.redirect-add': 'Add Redirect URI',
  'app.oidc-apps.detail-title': 'Application Detail',
  'app.oidc-apps.detail.app-name': 'Application Name',
  'app.oidc-apps.detail.status': 'Status',
  'app.oidc-apps.detail.auth-method': 'Auth Method',
  'app.oidc-apps.detail.secret-last4': 'Secret (last 4)',
  'app.oidc-apps.detail.secret-created-at': 'Secret Created At',
  'app.oidc-apps.detail.redirect-uris': 'Allowed Redirect URIs',
  'app.oidc-apps.secret-modal-title': 'Save Client Secret Now',
  'app.oidc-apps.secret-modal-ok': 'I have saved it',
  'app.oidc-apps.secret-modal-warning':
    'This Client Secret will only be shown once. You will not be able to view it after closing.',
  // ===== OIDC Application Detail - Redirect URI Management =====
  'app.oidc-apps.status.active': 'Active',
  'app.oidc-apps.status.disabled': 'Disabled',
  'app.oidc-apps.status.deleted': 'Deleted',
  'app.oidc-apps.detail.basic-info': 'Basic Information',
  'app.oidc-apps.detail.client-id': 'Client ID',
  'app.oidc-apps.detail.secret-display': '****{last4}',
  'app.oidc-apps.detail.created-at': 'Created At',
  'app.oidc-apps.detail.redirect-uri-mgmt': 'Redirect URI Management',
  'app.oidc-apps.detail.add-redirect-uri': 'Add Redirect URI',
  'app.oidc-apps.detail.col.redirect-uri': 'Redirect URI',
  'app.oidc-apps.detail.col.created-at': 'Created At',
  'app.oidc-apps.detail.col.actions': 'Actions',
  'app.oidc-apps.detail.action.edit': 'Edit',
  'app.oidc-apps.detail.action.delete': 'Delete',
  'app.oidc-apps.detail.delete-confirm-title': 'Delete this redirect URI?',
  'app.oidc-apps.detail.delete-confirm-desc':
    'Authorization requests using this URI will fail after deletion.',
  'app.oidc-apps.detail.delete-ok': 'Delete',
  'app.oidc-apps.detail.delete-cancel': 'Cancel',
  'app.oidc-apps.detail.add-modal-title': 'Add Redirect URI',
  'app.oidc-apps.detail.edit-modal-title': 'Edit Redirect URI',
  'app.oidc-apps.detail.form.redirect-uri': 'Redirect URI',
  'app.oidc-apps.detail.form.redirect-uri-required':
    'Please enter a redirect URI',
  'app.oidc-apps.detail.form.redirect-uri-https':
    'Redirect URI must start with https://',
  'app.oidc-apps.detail.form.redirect-uri-placeholder':
    'https://example.com/callback',
  'app.oidc-apps.detail.modal.add-ok': 'Add',
  'app.oidc-apps.detail.modal.save-ok': 'Save',
  'app.oidc-apps.detail.modal.cancel': 'Cancel',
  'app.oidc-apps.detail.add-success': 'Redirect URI added successfully',
  'app.oidc-apps.detail.add-failed': 'Failed to add redirect URI',
  'app.oidc-apps.detail.edit-success': 'Redirect URI updated successfully',
  'app.oidc-apps.detail.edit-failed': 'Failed to update redirect URI',
  'app.oidc-apps.detail.delete-success': 'Redirect URI deleted',
  'app.oidc-apps.detail.delete-failed': 'Failed to delete redirect URI',
  'app.oidc-apps.detail.default-title': 'OIDC Application Detail',
  'app.oidc-apps.action.manage-redirect-uris': 'Manage Redirect URIs',
  // ===== OIDC Application List - Hardcoded Text =====
  'app.oidc-apps.status-confirm-title': 'Confirm {label}',
  'app.oidc-apps.status-confirm-content':
    'Are you sure you want to {label} the application "{name}"?',
  'app.oidc-apps.status-updated': '{label} done',
  'app.oidc-apps.status-update-failed': 'Operation failed',
  'app.oidc-apps.delete-confirm-content':
    'Are you sure you want to delete the application "{name}"? This action cannot be undone.',
  'app.oidc-apps.deleted': 'Deleted',
  'app.oidc-apps.create-modal-redirect-label': 'Redirect URIs (one per line)',
  'app.oidc-apps.create-modal-redirect-required':
    'At least one redirect URI is required',
  'app.oidc-apps.create-modal-redirect-https':
    'Redirect URI must start with https://: {uri}',
  'app.oidc-apps.secret-save-warning':
    'Please save the following Client Secret now. It will not be shown again after closing.',
  'app.oidc-apps.secret-close-button': 'I have saved it, close',
  'app.oidc-apps.total-count': '{total} total',
  // ===== Device List =====
  'app.device.tooltip.user-enrollment': 'User Enrollment',
  'app.device.tooltip.legacy-enrollment': 'Legacy Enrollment',
  'app.device.search-serial': 'Search serial number',
  'app.device.profile-update-success': 'Profile updated successfully',
  'app.device.profile-update-failed': 'Failed to update profile',
  'app.device.command-network-error': 'The network request failed.',
  'app.device.enrollment-profile.select-skip':
    'Please select your skip setup item.',
  'app.device.enrollment-profile.org-magic': 'Enter org magic',
  'app.device.enrollment-profile.department': 'Enter department',
  'app.device.enrollment-profile.support-phone': 'Enter support phone number',
  'app.device.enrollment-profile.support-email': 'Enter support email address',
  // ===== Security Settings =====
  'app.security.password-strength.strong': 'Strong',
  'app.security.password-strength.medium': 'Medium',
  'app.security.password-strength.weak': 'Weak',
  'app.security.mfa.bound':
    'OTP device bound. You can use dynamic verification codes for two-factor authentication.',
  'app.security.mfa.unbound':
    'No MFA device bound. After binding, you can perform secondary verification.',
  // ===== Certificate Operations =====
  'app.cert.apns-title': 'APNS Certificate Management',
  'app.cert.domain-title': 'Domain Certificate Management',
  'app.cert.abm-title': 'ABM Certificate Management',
  'app.cert.label.match': 'Cert and private key match',
  'app.cert.label.create-date': 'Create date',
  'app.cert.label.expire-date': 'Expire date',
  'app.cert.label.issuer': 'Issuer',
  'app.cert.label.subject': 'Subject',
  'app.cert.label.remark': 'Remark',
  'app.cert.label.cert-code': 'Cert code',
  'app.cert.upload-success': 'Certificate uploaded successfully!',
  'app.cert.upload-failed': 'Upload failed',
  'app.cert.info-desc':
    'View the basic information of the management business.',
  // ===== Business Info =====
  'app.business.info-title': 'Business info',
  'app.business.edit-title': 'Edit business settings',
  'app.business.save-success': 'Business settings saved',
  'app.business.save-failed': 'Failed to save business settings',
  'app.business.tooltip.system-allocation':
    'System allocation, this value cannot be modified.',
  'app.business.tooltip.current-domain':
    'Current domain name, this value cannot be modified.',
  'app.business.tooltip.apns-locked':
    'After uploading the apns certificate, this value cannot be modified.',
  'app.business.request-cert-title': 'Business Request Certificate info',
  // ===== Enrollment Settings =====
  'app.enrollment.settings-saved': 'Enrollment settings saved.',
  'app.enrollment.fallback-synced': 'Fallback discovery synced.',
  'app.enrollment.fallback-sync-failed': 'Fallback discovery sync failed.',
  'app.enrollment.no-sync-message': 'No sync message.',
  'app.enrollment.sync-fallback-button': 'Sync Fallback Discovery',
  // ===== Dashboard =====
  'app.dashboard.device-status': 'Device status',
  'app.dashboard.message': 'Message',
  'app.dashboard.event-queue': 'Event queue',
  'app.dashboard.summary': 'Summary',
  'app.dashboard.params': 'Params',
  'app.dashboard.unread': 'UNREAD',
  // ===== Upload / Assets =====
  'app.upload.limit-one': 'You may upload only one file.',
  'app.assets.copied': 'Copied!',
  'app.assets.copy-failed': 'Copy failed',
  // ===== OIDC Interaction =====
  'app.oidc.interaction.tenant': 'Tenant',
  'app.oidc.interaction.client': 'Client',
  'app.oidc.interaction.redirect-uri': 'Redirect URI',
  'app.oidc.interaction.requested-scopes': 'Requested scopes',
  'app.oidc.interaction.effective-scopes': 'Effective scopes',
  'app.oidc.interaction.family-name': 'Family Name',
  'app.oidc.interaction.given-name': 'Given Name',
  'app.oidc.interaction.department': 'Department',
  'app.oidc.interaction.verification-code': 'Verification Code',
  // ===== Login =====
  'app.login.title': 'AegisMDM Login',
  // ===== Register =====
  'app.register.success': 'Registration successful!',
  // ===== Upload Media =====
  'app.upload-media.category': 'Category',
  'app.upload-media.remark': 'Remark',
  'app.upload-media.image': 'Image',
  'app.upload-media.select-file': 'Select media file',
  // ===== Business Tabs =====
  'app.business.tab.base': 'Basic Info',
  'app.business.tab.request-cert': 'Request Certificate',
  'app.business.tab.enrollment-settings': 'Enrollment Settings',
  // ===== Certificate Tabs =====
  'app.cert.tab.certificate': 'Certificate',
  'app.cert.tab.discussion': 'Discussion',
  // ===== Register Page =====
  'app.register.title': 'Register',
  'app.register.email-placeholder': 'Email',
  'app.register.email-required': 'Please enter email address!',
  'app.register.email-invalid': 'Invalid email format!',
  'app.register.password-placeholder': 'At least 6 characters, case sensitive',
  'app.register.password-required': 'Please enter password!',
  'app.register.password-mismatch': 'Passwords do not match!',
  'app.register.confirm-placeholder': 'Confirm password',
  'app.register.confirm-required': 'Confirm password',
  'app.register.mobile-placeholder': 'Phone number',
  'app.register.mobile-required': 'Please enter phone number!',
  'app.register.mobile-invalid': 'Invalid phone number format!',
  'app.register.captcha-placeholder': 'Verification code',
  'app.register.captcha-required': 'Please enter verification code!',
  'app.register.get-captcha': 'Get Code',
  'app.register.submit': 'Register',
  'app.register.login-link': 'Login with existing account',
  'app.register.strength-strong': 'Strength: Strong',
  'app.register.strength-medium': 'Strength: Medium',
  'app.register.strength-weak': 'Strength: Too short',
  'app.register.password-hint':
    'Please enter at least 6 characters. Do not use easily guessable passwords.',
  // ===== OIDC Interaction Labels =====
  'app.oidc.interaction.label.tenant': 'Tenant',
  'app.oidc.interaction.label.client': 'Client',
  'app.oidc.interaction.label.redirect-uri': 'Redirect URI',
  'app.oidc.interaction.label.requested-scopes': 'Requested scopes',
  'app.oidc.interaction.label.effective-scopes': 'Effective scopes',
  'app.oidc.interaction.placeholder.family-name': 'Family Name',
  'app.oidc.interaction.placeholder.given-name': 'Given Name',
  'app.oidc.interaction.placeholder.department': 'Department',
  'app.oidc.interaction.placeholder.verification-code': 'Verification Code',

  // ===== Certificate Discussion =====
  'app.cert.discussion.title.timeline': 'Certificate Application Process',
  'app.cert.discussion.timeline.domain':
    'Apply domain certificate [It can be automatically operated by the system]',
  'app.cert.discussion.timeline.mdm': 'Apply mdm certificate',
  'app.cert.discussion.timeline.apns': 'Apply apns certificate',
  'app.cert.discussion.timeline.abm': 'Apply abm certificate',
  'app.cert.discussion.title.domain': '1. Domain Certificate (TLS/SSL)',
  'app.cert.discussion.content.domain':
    "The **Domain Certificate (TLS/SSL)** is used to secure the connection between Apple devices and the Aegis MDM system. Apple requires all MDM traffic to be encrypted via HTTPS with a trusted certificate.\n\n- **Automated Mode**: The system can automatically operate and manage this using Let's Encrypt / ACME challenges.\n- **Manual Mode**: You can purchase a TLS/SSL certificate from a trusted Certificate Authority (CA) and upload the private key (`.key`) and full chain certificate (`.crt` or `.pem`) manually.",
  'app.cert.discussion.title.mdm': '2. MDM Vendor Certificate',
  'app.cert.discussion.content.mdm':
    'The **MDM Vendor Certificate** is prepared for the next step—generating the APNs push certificate. You need to first download the Certificate Signing Request (CSR) file, go to the Apple Developer portal, upload the CSR file, and then download the corresponding MDM certificate.\n\n1. Log in to the Apple Developer Portal (https://developer.apple.com/account), and navigate to the Certificates, IDs & Profiles section.\n2. Click the plus symbol (+) next to *Certificates*.\n3. Select *MDM CSR* under the *Services* section, click *Continue*.\n4. Upload the `VendorCertificateRequest.csr` file, click *Continue*.\n5. Click *Download* to download the certificate (usually named `mdm.cer`).\n6. Upload this MDM certificate back to the system to sign the final Push CSR.',
  'app.cert.discussion.title.apns': '3. APNs Push Certificate',
  'app.cert.discussion.content.apns':
    'The **APNs (Apple Push Notification service) Certificate** is required to send push notifications to wake up devices so they can check in with the MDM server.\n\n1. First, download the signed **Push CSR** (encoded with the MDM Vendor Certificate) from the Aegis MDM system.\n2. Go to the Apple Push Certificates Portal (https://identity.apple.com/pushcert/) and log in with your Managed Apple ID.\n3. Click *Create a Certificate*.\n4. Read and agree to the Terms of Use, then upload the downloaded Push CSR file.\n5. Click *Upload* and then *Download* the generated APNs certificate (a `.pem` file).\n6. Upload this APNs certificate into the Aegis MDM system to enable device push capabilities.',
  'app.cert.discussion.title.abm': '4. ABM Server Token',
  'app.cert.discussion.content.abm':
    'The **ABM (Apple Business Manager) Server Token** establishes a trust relationship between your Aegis MDM server and Apple Business Manager, allowing the system to sync devices and use Automated Device Enrollment (ADE).\n\n1. Download the **MDM Server Public Key** (`.pem` or `.crt`) from the Aegis MDM system.\n2. Go to Apple Business Manager (https://business.apple.com) and log in.\n3. Click on your profile name at the bottom left, select *Preferences*, and navigate to *Your MDM Servers*.\n4. Click *Add MDM Server*, enter a name for the server, and upload the Public Key downloaded in step 1.\n5. Save the server, then click *Download Token* to download the MDM server token (a `.p7m` or `.vpptoken` file).\n6. Upload this Server Token to the Aegis MDM system to complete the ABM integration.',
};
